import { Colors, Spacing } from 'cio-design-library/design-tokens'
import styled, { css } from 'styled-components'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div<{ $showBorder?: boolean }>`
  display: flex;
  padding: ${Spacing.L};
  gap: ${Spacing.L};
  cursor: pointer;
  border-radius: ${Spacing.S};
  background: ${Colors.White};
  height: 166px;
  max-width: 448px;
  ${Media.Tablet`
    height: 276px;
    max-width: 270px;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    `}

  ${Media.Phone`
    max-width: unset;
    height: 216px;
  `}

  ${({ $showBorder }) =>
    $showBorder &&
    css`
      border: 1px solid ${Colors.Neutral15};
      &:hover {
        box-shadow: 0px 16px 64px -8px rgba(15, 56, 113, 0.18),
          0px 6px 8px -2px rgba(15, 56, 113, 0.02), 0px 0px 1px 0px rgba(15, 56, 113, 0.32);
        transition: box-shadow 0.2s ease-in;
      }
    `}
`
export const Img = styled.div`
  ${Media.Tablet`
 
      display: flex;
    justify-content: center;
    `}
  & img {
    width: 112px;
    height: auto;

    ${Media.Tablet`
      width: auto;
      height: 80px;

    `}
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3XS']};
  justify-content: center;
`

export const Title = styled.div`
  ${Typography.Body};
  ${FontWeights.Medium};

  color: ${Colors.Neutral90};
`

export const Subtitle = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};

  color: ${Colors.Neutral50};
`
